import React, { createContext, useReducer } from 'react';
import { useUserContext } from './UserContext';

// Объект контекста
export const StatusContext = createContext({});

// Начальное состояние задач
const initialState = {
  status: [], // Массив задач
  filterBy: '', // Текущий фильтр (статус или другое условие)
  hostname: process.env.REACT_APP_API_URL || "" //process.env.REACT_APP_API_URL
};

// Редюсер для изменения состояния задач
const statusReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_ST':
      return {
        ...state,
        status: [...state.status, action.payload.status],
      };
    case 'UPDATE_ST':
      return {
        ...state,
        status: state.status.map(statu => {
         return statu._id === action.payload.id ? action.payload.UPDstatu : statu
        }
        ),
      };
    case 'DELETE_STATUS':
      return {
        ...state,
        status: state.status.filter(statu => statu._id !== action.payload.id),
      };
    // case 'FILTER_TASKS':
    //   return {
    //     ...state,
    //     filterBy: action.payload.filterValue,
    //   };
    case 'GET_ST':
      return {
        ...state,
        status: action.payload.status,
      };
    default:
      return state;
  }
};

// Экспорт самого контекста
export default StatusContext;
export const StatusProvider = ({ children }) => {
  const [state, dispatch] = useReducer(statusReducer, initialState);
  const {logout} = useUserContext();
  // Методы для манипуляции задачами
  const addStatus = async (credentials) =>{
    try{
    
    const response = await fetch(initialState.hostname+'/status/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
      if (data.success) {
        dispatch({
          type: 'ADD_ST',
          payload: { status: credentials },
        });
      }
    
    } catch (err) {
      console.error(err);
    }
  };

  const editStatus = async (credentials, id) =>{
    try{
    const response = await fetch(initialState.hostname+'/status/update/' + id, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
      if (data.success) {
        dispatch({ type: 'UPDATE_ST', payload: { id: id, UPDstatu: {...credentials, _id: id} } });
      }
    
    } catch (err) {
      console.error(err);
    }
  };

//   const updateTask = updatedTask => {
//     let id =testTask.findIndex((task)=>{ return task.id === updatedTask.id})
//     testTask[id] = updatedTask
//     dispatch({ type: 'UPDATE_TASK', payload: { id: updatedTask.id, updatedTask } });
//   };

const deleteState = async id => {
    try {
      const response = await fetch(initialState.hostname+'/status/status/'+ id, {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
        dispatch({ type: 'DELETE_STATUS', payload: { id } });
        return data;
    } catch (error) {
      console.log(error);
    }
    
  };

//   const applyFilter = filterValue => {
//     dispatch({ type: 'FILTER_TASKS', payload: { filterValue } });
//   };

  const getStatus = async () => {
    try {
      const response = await fetch(initialState.hostname+'/status/getStatus', {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
        dispatch({ type: 'GET_ST', payload: { status: data.data } });
        return data;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <StatusContext.Provider value={{
      status: state.status,
      filterBy: state.filterBy,
      addStatus,
      editStatus,
      deleteState,
    //   applyFilter,
      getStatus,
    }}>
      {children}
    </StatusContext.Provider>
  );
};
export const useStatusContext = () => {
  const context = React.useContext(StatusContext);
  if (!context) throw new Error("useStatusContext must be used within a UserProvider");
  return context;
};